var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',[_c('card-content',[_c('pre',{directives:[{name:"highlightjs",rawName:"v-highlightjs",value:(_vm.source),expression:"source"}]},[_c('code',{staticClass:"html"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }